import React from 'react'
import { CompleteOral, NearZero } from '../../../images'

function Cards() {
  return (
    <div className="md:flex md:justify-between mx-6 md:mx-auto md:w-4/6 my-8 md:my-16">
      <div className="flex md:max-w-1/2 max-h-min gap-8 py-4">
        <img alt='near-zero' src={NearZero} className="w-20 h-20 mt-4 md:mt-0"/>
        <div className="">
          <h3 className="text-lg md:text-xl text-secondary">Our Vision</h3>
          <p className="text-sm md:text-lg text-gray-600">Restoring patients' smiles to help them regain optimum helath and wellness by transofrming their aesthetic, self-esteem and social lives.</p>
        </div>
      </div>
      <div className="flex md:max-w-1/2 gap-8 py-4">
        <img alt='complete-oral' src={CompleteOral} className="w-20 h-20 mt-4 md:mt-0"/>
        <div className="">
          <h3 className="text-lg md:text-xl text-secondary">Contact Us</h3>
          <p className="text-sm md:text-lg text-gray-600">Address 1 goes here asdfjhsadlkjfhds</p>
          <p className="text-sm md:text-lg text-gray-600">Address 2 goes here dsakhsflhdfljkhds</p>
          <p className="text-sm md:text-lg text-gray-600">Phone xxx xxxxxxxx</p>
        </div>
      </div>
    </div>
  )
}

export default Cards
